import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Capacitor } from '@capacitor/core'
import App from './App'
import { SEOErinnerungen } from './pages/SEOErinnerungen'
import { SEOBeweissicherung } from './pages/SEOBeweissicherung'
import { SEOGeraetewechsel } from './pages/SEOGeraetewechsel'
import { SEODrucken } from './pages/SEODrucken'
import { SEOAnleitung } from './pages/SEOAnleitung'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function WebOnlyRoute({ element }: { element: React.ReactElement }) {
  if (Capacitor.isNativePlatform()) return <Navigate to="/" replace />
  return element
}

export function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/erinnerungen" element={<WebOnlyRoute element={<SEOErinnerungen />} />} />
        <Route path="/beweissicherung" element={<WebOnlyRoute element={<SEOBeweissicherung />} />} />
        <Route path="/geraetewechsel" element={<WebOnlyRoute element={<SEOGeraetewechsel />} />} />
        <Route path="/drucken" element={<WebOnlyRoute element={<SEODrucken />} />} />
        <Route path="/anleitung" element={<WebOnlyRoute element={<SEOAnleitung />} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
